module.exports = __webpack_public_path__ + "img/safari.c32d2a72.svg";